import { gql } from '@apollo/client'

export const COMLOG_QUERY = gql`
  query ComLogs($input: ComLogFilters!) {
    comLogs(input: $input) {
      comLogs {
        Date
        EndpointName
        EndpointURL
        Id
        Status
        UserIP
        UserId
        Request
        Response
      }
      pageInfo {
        current_page
        from
        lastPage
        perPage
        to
        total
      }
    }
  }
`
